import service from "../util/http";
// 零部件类别
export const getComponentCategoryList = () => {
  return service({
    url: "customer/car/feedback/getComponentCategoryList",
    method: "get",
  });
};
// 新建质量反馈
export const newFeedback = (data) => {
  return service({
    url: "/customer/car/feedback/add",
    method: "post",
    data,
  });
};
// 上传文件
export const uploadFile = (data) => {
  return service({
    url: "/manage/car/feedback/upload/file/customer",
    method: "post",
    data,
  });
};

// 列表
export const feedbackList = (data) => {
  return service({
    url: "/customer/car/feedback/list",
    method: "post",
    data,
  });
};
// 是否同意
export const isPass = (data) => {
  return service({
    url: "/customer/car/feedback/verify",
    method: "post",
    data,
  });
};
// 详情
export const feedBackDetail = (data) => {
  return service({
    url: "/customer/car/feedback/detail",
    method: "post",
    data,
  });
};
// 知会运单信息表
export const knowWaybill = (data) => {
  return service({
    url: "/customer/car/feedback/notify/complete",
    method: "post",
    data,
  });
};

// 质量反馈单删除
export const deleteEmptyFormApi = (questionId) => {
  return service({
    url: "/customer/car/feedback/deleteEmptyForm?feedbackFormId=" + questionId,
    method: "post",
  })
}

// （售前车 | 售后车）质量反馈列表
export const preAfterSalesListApi = (data) => {
  return service({
    url: "/customer/car/feedback/list",
    method: "post",
    data,
  });
};

// (售前车 | 售后车)问题列表
export const preAfterSalesQuestionListApi = (data) => {
  return service({
    url: "/customer/car/feedback/questionList",
    method: "post",
    data,
  });
};

// 根据车型获取vin列表信息
export const checkModelApi = (data) => {
  return service({
    url: "/customer/car/feedback/checkModel",
    method: "post",
    data,
  });
};

// 售前车问题新增
export const preProblemAddApi = (data) => {
  return service({
    url: "/customer/car/feedback/add",
    method: "post",
    data,
  });
};

// 售前车问题编辑
export const preProblemEditApi = (data) => {
  return service({
    url: "/customer/car/feedback/edit",
    method: "post",
    data,
  });
};

// 售前车问题删除
export const preProblemDeleteApi = (data) => {
  return service({
    url: "/customer/car/feedback/removeQuestion",
    method: "post",
    data,
  });
};

// 售后车反馈单新增
export const afterFeedbackAddApi = (data) => {
  return service({
    url: "/customer/car/feedback/addAfter",
    method: "post",
    data,
  });
};

// 售后车反馈单编辑
export const afterFeedbackEditApi = (data) => {
  return service({
    url: "/customer/car/feedback/editAfter",
    method: "post",
    data,
  });
};

// 售后车问题编辑
export const afterProblemEditApi = (data) => {
  return service({
    url: "/customer/car/feedback/editQuestion",
    method: "post",
    data,
  });
};

// （售前车 | 售后车）质量反馈提交
export const preAfterSubmitApi = (data) => {
  return service({
    url: "/customer/car/feedback/submit",
    method: "post",
    data,
  });
};

// 获取车架号数据
export const getCarDataByVinApi = (data) => {
  return service({
    url: "/customer/car/feedback/getModel",
    method: "post",
    data,
  });
};
// 获取疑似/祸首件名称
export const getCheckPartApi = (data) => {
  return service({
    url: "/customer/car/feedback/checkPart",
    method: "post",
    data,
  });
};
// 审核
export const auditProblem = (data) => {
  return service({
    url: "/customer/car/feedback/audit",
    method: "post",
    data,
  });
};

// 审核记录
export const auditHistoryList = data => {
  return service({
    url: "/customer/car/feedback/auditHistoryList",
    method: "post",
    data
  });
};
// 审核临时措施驳回通过
export const dealerAuditApi = data => {
  return service({
    url: "/customer/car/feedback/dealerAudit",
    method: "post",
    data
  });
};

// 请求任务详情
export const requestTaskDetail = data => {
  return service({
    url: "/customer/car/feedback/getTaskById",
    method: "get",
    params:data
  });
};
// 导出质量反馈
export const exportFeedback = (data) => {
  return service({
    url: "/customer/car/feedback/export",
    method: "post",
    responseType: "blob",
    data,
  });
};

//根据订单号查询订单数量
export const getVehicleAmountByOrderNumber = data => {
  return service({
    url: "/customer/car/feedback/getVehicleAmountByOrderNumber?orderNumber=" + data,
    method: "get",
  });
};